( function ($) {
    var all_maps = {};
    var all_markers = {};
    var all_bounds = {};
    var marker_status = {};
    var all_infowindows = {};

    $(document).ready(function () {
        changeMode();
        showItineraryButton();
        var map_position = $('#map_canvas').offset().top - $('#map_canvas').height();
        var window_height = $(window).height();
        var map_processed = false;

        if (map_position > window_height) {
            $(window).on("scroll", function () {
                var scrollPosition = window.pageYOffset;
                if (scrollPosition >= map_position && map_processed === false) {
                    initMap();
                    map_processed = true;

                }
            });
        }else{
            initMap();
            map_processed = true;
        }

    });

    function showItineraryButton() {
        $('select[name="hotel_itinerary_sel"]').on('change', function () {
            var classItinerary = '.' +  $(this).val();
            console.log(classItinerary);
            $('.map_itinerary_btn').hide();
            $(classItinerary).fadeIn();
        });
    }


    function changeMode() {
        var button_itinerary_mode = $('.itinerary_mode');
        button_itinerary_mode.click(function (e) {
            e.stopPropagation();
            // this
            var anchor = $(this);
            // check
            if (anchor.hasClass('active')) return false;
            // reset
            $('.itinerary_mode.active').removeClass('active');
            // adding class
            anchor.addClass('active');
        });
    }

    function detectMode() {

        var anchorSelected = $('.itinerary_mode.active');
        return anchorSelected.attr('data-travelmode');

    }

    function initMap() {


        $('#map_canvas').each(function () {
            var container = $(this),
                outer_container = container.parent(),
                div_id = container.attr('id');
            initialize_map_multi(div_id);
            outer_container.find('.category a').click(function () {
                var category = $(this).data('category');
                var category_title = $(this).text();

                if ($(this).parent().hasClass('active')) {
                    toggle_category('', div_id);
                    $(this).parent().removeClass('active');
                } else {
                    toggle_category(category, div_id);
                    $('.category a').parent().removeClass('active');
                    $(this).parent().addClass('active');
                }
                if ($('html').hasClass('surroundings_page')) {
                    showPOIonSurroundingsPage(category, category_title);
                }

            });
        });


        $('#map_overlay .category li:first-child a').trigger("click");
        if ($('#map_directions').size() > 0) {
            initialize_calc_route();
            $('#itinerarySubmit').on('click', function () {

                var start = $('input#itineraryFrom').val();
                calcRoute(start, detectMode());
            });
        }
    }


    function initialize_calc_route() {
        mapConfig = {mode: 'car', currentHotel: {}};
        //$('#itinerarySubmit').click(calcRoute);
        $('#itineraryMode').click(function () {
            if ($(this).hasClass('car')) {
                mapConfig.mode = 'feet';
                $(this).removeClass('car').addClass('feet').html($(this).attr('data-feet')).attr('title', $(this).attr('data-feet'));
            } else {
                mapConfig.mode = 'car';
                $(this).removeClass('feet').addClass('car').html($(this).attr('data-car')).attr('title', $(this).attr('data-car'));
            }
        });
    };

    function initialize_map_multi(div_id) {
        if (typeof (all_bounds[div_id]) === "undefined") all_bounds[div_id] = new google.maps.LatLngBounds();
        map_zoom = (typeof map_zoom === 'undefined') ? 14 : map_zoom;

        all_maps[div_id] = new google.maps.Map(document.getElementById(div_id), {
            // scroll wheel
            scrollwheel: false,
            //zoom
            zoom: map_zoom,
            center: new google.maps.LatLng(hotel_gps_coordinates.latitude, hotel_gps_coordinates.longitude),
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            //map type
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
                style: google.maps.MapTypeControlStyle.DEFAULT
            },
            // default pan control
            panControl: false,
            scaleControl: false,
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            }
        });

        var styles = styleResolved;
        create_markers(div_id);
        show_markers(div_id);

        all_maps[div_id].setOptions({styles: styles});
        all_maps[div_id].setOptions({mapTypeId: map_type});



        directionsService = new google.maps.DirectionsService(), directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: false,
            markerOptions: {zIndex: 10}
        });
    }

    function create_markers(div_id) {
        all_markers[div_id] = {};
        for (var i = 0; i < map_data.markers.length; i++) {
            var el = map_data.markers[i];
            var is_hotel = el.slug == 'hotel';
            var image_url = map_data.icon;
            var image_size = new google.maps.Size(36, 36);
            var scaled_size = new google.maps.Size(36, 36);
            if (
                typeof el.image !== 'undefined' &&
                typeof el.image_size_w !== 'undefined' &&
                typeof el.image_size_h !== 'undefined'
            ) {
                image_url = el.image;
                image_size = new google.maps.Size(el.image_size_w, el.image_size_h);
                scaled_size = new google.maps.Size(36, 36)
            } else if (is_hotel) {
                image_url = map_data.icon_hotel;
                image_size = new google.maps.Size(48, 70);
                scaled_size = new google.maps.Size(48, 70);
            }

            var image = {
                url: image_url,
                size: image_size,
                scaledSize: scaled_size,
                anchor: new google.maps.Point(22, 52)
            };
            all_markers[div_id][i] = new google.maps.Marker({
                position: new google.maps.LatLng(el.latitude, el.longitude),
                map: null,
                icon: image
            });


            var callback = (function (div_id, marker_id) {
                return function () {
                    show_marker_infowindow(marker_id, div_id);
                }
            })(div_id, i);
            all_markers[div_id][i].addListener('click', callback);
        }
    }

    function show_markers(div_id, only_fitbounds) {
        var visible_counter = 0, center;
        if (typeof only_fitbounds === 'undefined') {
            only_fitbounds = false;
        }
        all_bounds[div_id] = new google.maps.LatLngBounds();
        if (typeof marker_status[div_id] == 'undefined') {
            marker_status[div_id] = map_config[div_id].visible_markers;
        }
        for (var i = 0; i < map_data.markers.length; i++) {
            var el = map_data.markers[i];
            if (marker_status[div_id].indexOf(el.slug) != -1) {
                if (!only_fitbounds) {
                    all_markers[div_id][i].setMap(all_maps[div_id]);
                }
                all_bounds[div_id].extend(all_markers[div_id][i].getPosition());
                if (visible_counter == 0) {
                    center = all_markers[div_id][i].getPosition();
                }
                visible_counter++;
            } else {
                if (!only_fitbounds) {
                    all_markers[div_id][i].setMap(null);
                }
            }
        }
        if (visible_counter === 1) {
            all_maps[div_id].setCenter(center);
            all_maps[div_id].setZoom(map_config[div_id].default_zoom);
            google.maps.event.trigger(all_maps[div_id], 'resize');
        } else {
            window.clusterMarkers = all_markers[div_id];
            window.clusterMap = all_maps[div_id];
            var clusterStyles = [{
                textColor: '#000',
                url: map_data.icon_cluster,
                height: 55,
                width: 55,
                textSize: 16,
                textLineHeight: 55,
                fontWeight: 600,
                backgroundPosition: "2 1"
            }];

            window.markerCluster = new MarkerClusterer(clusterMap, clusterMarkers, {
                styles: clusterStyles,
                maxZoom: 16
            });

            all_maps[div_id].fitBounds(all_bounds[div_id]);
        }
    }

    /**
     * @param marker_id
     * @param div_id
     * @return boolean - true if marker was made visible, false if it was hidden
     */
    function toggle_marker_visibility(marker_id, div_id) {
        if (typeof div_id === 'undefined') {
            div_id = 'map_canvas';
        }
        if (marker_status[div_id].indexOf(marker_id) === -1) {
            marker_status[div_id].push(marker_id);
            show_markers(div_id);
            return true;
        } else {
            marker_status[div_id] = marker_status[div_id].filter(function (item) {
                return item !== marker_id;
            });
            show_markers(div_id);
            return false;
        }
    }

    function toggle_category(category, div_id) {
        marker_status[div_id] = ['hotel'];
        if (typeof map_data.markers_by_category[category] !== 'undefined') {
            for (var i = 0; i < map_data.markers_by_category[category].length; i++) {
                marker_status[div_id].push(map_data.markers_by_category[category][i]);
            }
        }
        show_markers(div_id);
    }

    function get_marker_data_by_id(marker_id) {
        for (var i = 0; i < map_data.markers.length; i++) {
            var el = map_data.markers[i];
            if (i == marker_id) {
                return el;
            }
        }
    }

    function show_marker_infowindow(marker_id, div_id, visible) {

        var marker = get_marker_data_by_id(marker_id),
            marker_title = marker.title;
        console.log(marker);
        if (typeof marker.lang !== 'undefined' && typeof marker.lang[siteLang] !== 'undefined') {
            marker_title = marker.lang[siteLang];
        }
        var marker_image = 'img/images/' + marker_id + '.jpg';
        var marker_thumb = '';
        var marker_content = '<div class="infowindow_content"><div class="wrap">' + marker_thumb + '<div class="contacts"><div class="title">' + marker_title + '</div>';
        if (!$.isEmptyObject(marker.address)) {
            marker_content += '<span class="address">' + marker.address + '</span>';
        }
        if (!$.isEmptyObject(marker.phone)) {
            marker_content += '<span class="phone"> ' + marker.phone + '</span>';
        }
        if (!$.isEmptyObject(marker.mail)) {
            marker_content += '<span class="mail"> ' + marker.mail + '</span>';
        }
        if (!$.isEmptyObject(marker.url)) {
            let strLink = 'Discover more';
            if (document.documentElement.lang === 'pt-pt') {
                strLink = 'Descobrir mais';
            }
            if (document.documentElement.lang === 'fr') {
                strLink = 'En savoir plus';
            }
            if (document.documentElement.lang === 'es') {
                strLink = 'Más información';
            }
            marker_content += '<span class="genericCta3 btn"><a href="'+ marker.url +'">'+strLink+'</a></span>';
        }
        marker_content += '</div></div></div>';
        if (typeof all_infowindows[div_id] === 'undefined') {
            all_infowindows[div_id] = new google.maps.InfoWindow({
                content: marker_content
            });
        } else {
            all_infowindows[div_id].setContent(marker_content);
        }
        all_infowindows[div_id].open(all_maps[div_id], all_markers[div_id][marker_id]);
    }

    function calcRoute(start, mode) {
        mode = mode || (mapConfig.mode == 'car' ? 'DRIVING' : 'WALKING');
        if ($('body').hasClass('single-hotel')){
            var end = $('.hotels input[name=single_hotel]').val(),
                request = {
                    origin: start,
                    destination: end,
                    travelMode: google.maps.DirectionsTravelMode[mode]
                }, itineraryTitle;
        }else{
            var end = $('.hotels select option:selected').attr('data-cords'),
                request = {
                    origin: start,
                    destination: end,
                    travelMode: google.maps.DirectionsTravelMode[mode]
                }, itineraryTitle;
        }



        if ($.trim(start) == '') {
            alert('insert the destination');
            return;
        }

        directionsService.route(request, function (response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                itineraryTitle = $('#itinerary_container .title span').html() + ' ' +
                    //itineraryTitle=$('#itinerarySubmit').html()+' '+
                    //$('#itineraryMode').attr('data-vers')+' '+
                    ':';
                if ($('.itineraryPanelWrapper').length == 0) {
                    $('#map_directions_content').append(
                        $('<div/>', {'class': 'itineraryPanelWrapper'})
                            .append($('<div/>', {'class': 'title'}))
                            .append($('<div/>', {id: 'itineraryPanel'}))
                    );
                }
                //	$('.itineraryPanelWrapper .title').html(itineraryTitle);
                directionsDisplay.setMap(all_maps['map_canvas']);
                directionsDisplay.setPanel(document.getElementById('itineraryPanel'));
                directionsDisplay.setDirections(response);

                if ($('#map_directions').size() > 0) {

                    $('#map_directions').fadeIn(function () {
                        $('.close').click(function () {
                            $('#map_directions').fadeOut(function () {
                                directionsDisplay.setMap(null);

                                if ($('body').hasClass('single-hotel')){
                                    var input = $('.hotels input[name=single_hotel]').val();
                                    var coords = input.split(',');
                                    //var hotel = new google.maps.LatLng(hotel_gps_coordinates.latitude, hotel_gps_coordinates.longitude);
                                    var hotel = new google.maps.LatLng(coords[0],coords[1]);
                                    all_maps['map_canvas'].setZoom(map_zoom);
                                    all_maps['map_canvas'].setCenter(hotel);
                                } else {
                                    all_maps['map_canvas'].setZoom(map_zoom);
                                    all_maps['map_canvas'].fitBounds(all_bounds['map_canvas']);
                                }
                            });
                        });
                    });
                }
            } else {
                alert('ERROR');
            }
        });
    };

    function showPOIonSurroundingsPage(category, category_title) {
        var title = category_title;
        var filter = '.filter_' + category;
        var pois_wrap = $('#blog_articles');
        var pois = pois_wrap.find('.post_wrap');
        pois_wrap.find('.wrap_title').text(title);
        if (filter == '.filter_000_all') {
            pois.css('display', 'block');
        } else {
            pois.css('display', 'none');
            pois_wrap.find('.post_wrap' + filter).css('display', 'block');
        }
    }

}(jQuery) );
